import React from "react";
import { BarChart3 } from "lucide-react";
import ChartRenderer from "../../charts/ChartRenderer";

const DashboardCharts = ({ charts = [] }) => {
  if (!charts.length) return null;

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-8">
      {charts.map((chart, index) => (
        <div
          key={index}
          className="group relative overflow-hidden rounded-2xl bg-white border border-slate-200 shadow-md
          hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
        >
          {/* Left Accent */}
          <div className="absolute left-0 top-0 h-full w-1 bg-cyan-500 transition-all duration-300 group-hover:w-2" />

          {/* Background Gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-50/60 via-white to-indigo-50/50 opacity-0 group-hover:opacity-100 transition-all duration-500" />

          <div className="relative p-6">
            {/* Header */}
            <div className="flex items-center justify-between mb-3">

              <div>
                <h2 className="text-xl font-bold text-slate-800">
                  {chart.title}
                </h2>

                <p className="text-sm text-slate-500 mt-1">
                  AI Generated Analytics
                </p>
              </div>

              <div className="h-12 w-12 rounded-xl bg-cyan-100 flex items-center justify-center group-hover:rotate-12 transition-all duration-500">
                <BarChart3
                  size={24}
                  className="text-cyan-600"
                />
              </div>

            </div>

            {/* Divider */}
            <div className="border-t border-slate-100 mb-3" />

            {/* Chart */}
            <ChartRenderer chart={chart} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardCharts;